import React, { FormEvent, useEffect, useState } from "react";
import VerificationInput from "react-verification-input";
import { useNavigate } from "react-router-dom";
import CircleButton from "src/Components/GlobalComponents/CircleButton";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import moment from "moment";
import { CircularProgress } from "@mui/material";

interface IOTPResponse {
  otpExpire?: string;
  message?: string;
  [key: string]: any; // Allow for any additional properties
}

interface ItwoFactor {
  email: string;
  otpExpire: string;
  purpose: "register" | "forget"; // add if any conditions use
  [key: string]: any; // Allow for any additional properties
}

const DoctorOtp: React.FC = () => {
  const navigate = useNavigate();

  const [purpose, setPurpose] = useState<string>("");
  const [otp, setOtp] = useState<string>(""); 
  const [isLoader, setIsLoader] = useState<boolean>(false); 
  const [isResendLoading, setIsResendLoading] = useState<boolean>(false);

  const [timeLeft, setTimeLeft] = useState<string>("00:00"); 
  const [email, setEmail] = useState<string>("");
  const [bool, setBool] = useState<boolean>(false);

  const formatTime = (seconds: string) => {
    const totalSeconds = Number(seconds);
    if (isNaN(totalSeconds) || totalSeconds < 0) {
      return "00:00";
    }
    const minutes = Math.floor(totalSeconds / 60);
    const secs = Math.floor(totalSeconds % 60);
    return `${minutes.toString().padStart(2, "0") || "00"}:${
      secs.toString().padStart(2, "0") || "00"
    }`;
  };

  // API_CALL: API call for resent OTP
  const resendOtp = async () => {
    setIsResendLoading(true);
    const { res, err } = await httpRequest<IOTPResponse>({
      method: "post",
      path: "/customer/recentOtp",
      params: { email: email.toLowerCase() , role: "doctor" },
    });
    if (res) {
      let { message = "" } = res;
      toast(message, { type: "success" });
      setOtp("");
      // Store relevant information in cookie
      let obj = {
        email,
        otpExpire: moment().add(2, "minutes").toISOString(),
        purpose,
      };
      sessionStorage.setItem(
        "doctorTwoFactor" as string,
        JSON.stringify(obj)
      );
      setBool((prev) => !prev); // Trigger timer update
    } else {
      toast(err, { type: "error" });
    }
    setIsResendLoading(false);
  };

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    if (!otp || otp.length < 4) {
      toast("OTP is required!", { type: "error" });
      return;
    }
    if (timeLeft == "00:00") {
      return toast.error("OTP Expired!");
    }
    setIsLoader(true);
    const { res, err } = await httpRequest<{ message: string }>({
      method: "post",
      path: "/customer/verfifcation",
      params: { otp, email: email.toLowerCase() },
    });
    if (res) {
      if (purpose === "forget") {
        toast("Verification Sucessfull! Please change password to continue.", {
          type: "success",
        });
        let obj = { email: email, otp: otp };
        sessionStorage.setItem("changePassword", JSON.stringify(obj));
        navigate("/doctor/confirm-password"); // Navigate to change passwordchange-password page
      } else {
        toast("Verification Sucessfull! Please log in to continue.", {
          type: "success",
        });
        navigate("/doctor/login"); // Navigate to login page
      }
      sessionStorage.removeItem("doctorTwoFactor"); // Clear session storage
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem("doctorTwoFactor");
    let info: ItwoFactor | null = null;
    if (storedData) {
      try {
        info = JSON.parse(storedData) as ItwoFactor;
      } catch (error) {
        console.error("Failed to parse session storage data:", error);
      }
    }
    if (!info) {
      // navigate(-1);
    } else {
      setEmail(info?.email);
      setPurpose(info?.purpose || "");
      const otpExpire = moment(info?.otpExpire);
      const interval = setInterval(() => {
        const now = moment();
        const diff = otpExpire.diff(now);
        if (diff <= 0) {
          setTimeLeft("00:00");
          clearInterval(interval);
        } else {
          setTimeLeft(String(moment.duration(diff).asSeconds()));
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [bool]);

  return (
    <div className="customer-login-main">
      <div className="container-1600">
        <div className="customer-login-main-inner">
          <h1 className="font-Poppins-SemiBold font-size-32px theme-color-green leading-none text-center">
            Verification code
          </h1>
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <div className="customer-login-main-inner-main items-center">
              <div className="verification-code">
                <VerificationInput
                  autoFocus={true}
                  length={4}
                  validChars="0-9"
                  placeholder="-"
                  value={otp}
                  onChange={(e) => setOtp(e)}
                  inputProps={{
                    id: "otp",
                  }}
                />
              </div>
              <div className="flex gap-1 items-center">
                <span className="font-size-16px text-white font-Poppins-Regular">
                  {formatTime(timeLeft)}
                </span>
                <button
                  className="text-[#2CDED3] font-size-16px font-Poppins-SemiBold hover:underline disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                  disabled={timeLeft !== "00:00" || isResendLoading}
                  onClick={resendOtp}
                  type="button"
                  id="resend_btn"
                >
                  {isResendLoading ? (
                    <>
                      <CircularProgress size={16} style={{ color: "#2CDED3" }} />
                      <span>Resending...</span>
                    </>
                  ) : (
                    "Resend Code"
                  )}
                </button>
              </div>
              <div className="login-btn-home-banner-parent flex items-center justify-center">
                <CircleButton
                  // disabled={timeLeft == "00:00"}
                  ButtonText={"Verify"}
                  loader={isLoader}
                  type={"submit"}
                  btnExtralClasses={
                    "border border-[#00443f] hover:bg-[#fff]  hover:text-[#00443f]"
                  }
                  id="submit_btn"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DoctorOtp;
